<template>
  <div style="background: #fff; padding: 20px; min-height: 500px;">
		<div v-show="sourceData.length">
			<div :id="chartId" style="width: 100%; height: 500px;"></div>
			<div :id="sliderId"></div>
		</div>
		<p v-show="sourceData.length <= 0"
			class="sx-align-center"
			style="color:#aaa;margin-top:200px;">暂无数据</p>
  </div>
</template>

<script>
  import G2 from '@antv/g2';
  import Slider from '@antv/g2-plugin-slider';
  import DataSet from '@antv/data-set';
  import sliderPng from './slider.png';

  export default {
    props: {
      sourceData: {
        type: Array,
        default: () => [
          // {
          // 	year: '2019-03-07',
          // 	number: 130
          // }
        ]
			},

			// type
			dataType: {
				type: Number,
				// 1-首页 单个柱状图
				// 2-已招生/计划招生 分组柱状图
				default: 1
			}
    },
    data() {
      return {
        chartId: '',
        sliderId: ''
      };
    },
    created() {
      this.chartId = 'chart-' + new Date().getTime();
      this.sliderId = 'slider-' + new Date().getTime();
    },
    mounted() {
			// 待Div渲染出来后再加载图表
			let sourceData = [{
					year: '2019-03-06',
					type: '已报名',
          number: 134
        }, {
					year: '2019-03-06',
					type: '计划招生',
          number: 134
        }, {
          year: '2019-03-07',
          number: 130
        }, {
          year: '2019-03-08',
          number: 34
        }, {
          year: '2019-03-09',
          number: 14
        }, {
          year: '2019-03-10',
          number: 34
        }, {
          year: '2019-03-11',
          number: 54
        }, {
          year: '2019-03-12',
          number: 94
        }, {
          year: '2019-03-13',
          number: 14
				}];

      this.initChart();
    },
    methods: {
			clearHtml() {
				document.getElementById(this.chartId).innerHTML = '';
				document.getElementById(this.sliderId).innerHTML = '';
			},

      initChart(sourceData) {
				sourceData = sourceData || this.sourceData;

				this.clearHtml();

				if (this.sourceData.length <= 0) return;

        const ds = new DataSet({
          state: {
            from: new Date(sourceData[0].year).getTime(),
            to: new Date(sourceData[sourceData.length - 1].year).getTime()
          }
        });

        const dv = ds.createView();

        dv.source(sourceData)
          .transform({
            type: 'filter',
            callback: obj => {
              return new Date(obj.year).getTime() >= ds.state.from && new Date(obj.year).getTime() <= ds.state.to;
            }
          });

        var chart = new G2.Chart({
          container: this.chartId,
          forceFit: true
        });

        chart.source(dv);

        chart.scale('year', {
          type: 'cat'
				})
				.tooltip({
					showTitle: false
				})

        chart.scale('number', {
          // tickInterval: 100,
          alias: '报名人数'
        });

        chart.axis('number', {
          label: {
            textStyle: {
              fill: '#aaaaaa'
            }
          },
          title: {
            position: 'center',
            textStyle: {
              // rotate: 0 // 文本旋转角度，以角度为单位，仅当 autoRotate 为 false 时生效
            }
          }
				});

				chart.legend(false);

				chart.interval()
				.position('year*number')
				.size('year', [30])

        chart.render();

        // 数据量少时无需Slider
        if (sourceData.length <= 10) return;

        let slider = new Slider({
          container: this.sliderId,
          start: ds.state.from,
          end: ds.state.to,
          xAxis: 'year',
          yAxis: 'number',

          data: sourceData,

          handleStyle: {
            img: sliderPng, // 可以使图片地址也可以是 data urls
            width: 5,
            height: 26
          },
          onChange: ({ startText, endText }) => {
            // !!! 更新状态量
            ds.setState('from', new Date(startText).getTime());
            ds.setState('to', new Date(endText).getTime());
          }
        });

        slider.render();
      }
    }
  };
</script>

<style lang="stylus" scoped>
</style>
